import { useTheme } from '@emotion/react';
import { Box, Button, Drawer } from '@mui/material';

export default function MobileDrawer({ isOpen, onClose }) {
  const theme = useTheme();

  return (
    <Drawer
      anchor="left"
      open={isOpen}
      onClose={onClose}
      ModalProps={{
        BackdropProps: {
          invisible: true,
        },
      }}
      sx={{
        '& .MuiDrawer-paper': {
          mt: '94px',
          height: 'calc(100% - 94px)',
          width: '100%',
          boxShadow: 'none',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          p: '0px 26px',
          [theme.breakpoints.down('sm')]: {
            width: '100%',
          },
        },
      }}
      transitionDuration={300}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            flex: 1,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '10px',
          }}
        >
          {[
            { id: 1, label: 'Produkte' },
            { id: 2, label: 'Doku' },
          ].map((button) => (
            <Button
              key={button.id}
              sx={{
                width: '100%',
                bgcolor: '#EFEFEF',
                textTransform: 'none',
                color: '#848484',
                fontFamily: 'Raleway',
                fontSize: '20px',
                fontWeight: '500',
              }}
            >
              {button.label}
            </Button>
          ))}
        </Box>

        <Box
          sx={{
            marginTop: 'auto',
            marginBottom: '30px',
          }}
        >
          <Button
            sx={{
              width: '100%',
              bgcolor: 'primary.main',
              textTransform: 'none',
              color: '#fff',
              fontFamily: 'Raleway',
              fontSize: '18px',
              fontWeight: '600',
            }}
            href="/organizer"
          >
            Login
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}
